module.exports = __webpack_public_path__ + "static/media/background-about.4ad658cd.png";